import { compose, mapProps, withHandlers } from 'recompose'
import { getResizedImageFromFile } from 'utils/files'

const emptyFile = {
  src: '',
  name: '',
  file: null,
  type: '',
  error: null,
  total: null,
  loaded: null,
}

export default compose(
  withHandlers({
    onDrop: props => async (acceptedFiles) => {
      if (acceptedFiles[0]) {
        const file = await getResizedImageFromFile(acceptedFiles[0])

        const newFile = {
          ...emptyFile,
          src: file,
          name: file.name,
          file: acceptedFiles[0],
          type: 'image',
          loaded: 0,
          total: file.size
        }

        props.onSelect(newFile)
      }
    },
  }),
  mapProps((ownerProps) => {
    return {
      error: ownerProps.error,
      onDrop: ownerProps.onDrop,
      onRemove: ownerProps.onRemove,
      hasImage: !!ownerProps.field.value,
      imageSrc: ownerProps.field.value ? 
        (ownerProps.field.value.src || ownerProps.field.value)
        : null,
      helperText: ownerProps.helperText
    }
  })
)




// WEBPACK FOOTER //
// ./src/components/organisms/ImageUpload/ImageUpload.enhancer.js